module.exports = __webpack_public_path__ + "img/variety.18ff7a17.png";